import React from "react";
import ListItem from "./ListItem";

function List({ components }) {
  const clist = components.filter(
    (component) =>
      component.name !== "Visit www.githubstatus.com for more information"
  );
  return (
    <div>
      <div className="App-intro">
        {clist.map((item, index) => (
          <ListItem key={index} item={item} />
        ))}
      </div>
    </div>
  );
}

export default List;
